<div mat-dialog-title>
  <h2>{{"monitoringTasks.monitorPrices" | translate}}</h2>
  <button mat-icon-button class="close" [disabled]="loading" aria-label="Close" (click)="openConfirmDialog()">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<form [formGroup]="formGroup" *ngIf="!dataLoading">
  <mat-dialog-content>
    <div class="mat-dialog-body products-tabs">
      <div class="products-strip" #thumbItem (scroll)="onStripScroll($event)">
        <div *ngFor="let product of products; let i = index" class="product-thumb" #thumbItem
          [class.selected]="i === selectedIndex" (click)="selectProduct(i)">
          <div class="thumb-img">
            <img [src]="product.productMainImageUrl" [alt]="product.productName" />
          </div>
          <p>{{ product.productName }}</p>
          <span *ngIf="product.isCompleted" class="check-badge">
            <svg xmlns="http://www.w3.org/2000/svg" width="9.988" height="7.278" viewBox="0 0 9.988 7.278">
              <path id="Path_109216" data-name="Path 109216"
                d="M260.456,127.057l5.77-5.77a.754.754,0,0,0-1.066-1.066l-5.237,5.237-2.177-2.253a.754.754,0,0,0-1.066,1.066l2.71,2.785a.754.754,0,0,0,1.066,0Z"
                transform="translate(-256.46 -120)" fill="#fff" />
            </svg>
          </span>
        </div>

        <div *ngIf="isLoading" class="thumb-loading">
          <mat-spinner diameter="24"></mat-spinner>
        </div>
      </div>

      <div class="product-detail-row">

        <button mat-icon-button class="next" (click)="goPrev()" [disabled]="selectedIndex === 0">
          <mat-icon>chevron_right</mat-icon>
        </button>

        <div class="product-card" *ngIf="selectedProductCard">
          <div class="product-img">
            <img [src]="selectedProductCard.productMainImageUrl" />
          </div>
          <p class="product-name">{{ selectedProductCard.productName }}</p>
        </div>

        <button mat-icon-button class="prev" (click)="goNext()"
          [disabled]="selectedIndex === products.length - 1 && products.length >= totalProductsCount">
          <mat-icon>chevron_left</mat-icon>
        </button>

      </div>

      <p class="counter">{{"monitoringTasks.product" | translate}} <span>{{ currentProductNumber }}</span>{{
        "general.of" | translate}} <span>{{ totalProductsCount }}</span></p>

      <div class="info-card" *ngIf="selectedProductCard">
        <div class="info-row">
          <div class="brand-block">
            <div class="brand-logo">
              <img *ngIf="selectedProductCard.brandLogoUrl" [src]="selectedProductCard.brandLogoUrl"
                (error)='selectedProductCard.brandLogoUrl = "assets/images/no_logo.png"'>
            </div>
            <div class="brand-name-block">
              <div class="info-label">{{"products.brand" | translate}}</div>
              <div class="info-value">{{selectedProductCard.brandName}}</div>
            </div>
          </div>
          <div class="info-block">
            <span class="info-label">
              {{"monitoringTasks.barcode" | translate}}
            </span>
            <span class="info-value">{{selectedProductCard.barcode}}</span>
          </div>
        </div>

        <div class="range-row">
          <span class="range-label">
            {{"monitoringTasks.expectedRange" | translate}}
          </span>
          <div>
            <span class="range-price">
              {{selectedProductCard.lowPrice}}
              <span class="currency-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
                  <path id="Saudi_Riyal_Symbol"
                    d="M16529.955,11555.947l6.043-1.293a6.589,6.589,0,0,1-.547,2.054l-6.043,1.293A6.683,6.683,0,0,1,16529.955,11555.947Zm-9.41-1.357,5.1-1.092v-2.438l-4.76,1.019a6.632,6.632,0,0,1,.545-2.055l4.215-.9v-7.531a6.609,6.609,0,0,1,1.881-1.59v8.72l1.881-.4v-5.778a6.693,6.693,0,0,1,1.883-1.592v6.967l4.707-1.007a6.588,6.588,0,0,1-.547,2.055l-4.16.89v1.937l4.707-1.008a6.588,6.588,0,0,1-.547,2.055h0l-6.043,1.293v-3.874l-1.881.4v2.149a.926.926,0,0,1-.162.528h0l-.977,1.462a1.7,1.7,0,0,1-1.053.705l-5.338,1.142A6.629,6.629,0,0,1,16520.545,11554.59Z"
                    transform="translate(-16519.998 -11540.001)" fill="#786800" />
                </svg>
              </span>
            </span>
            <span class="range-arrow">
              🡨
            </span>
            <span class="range-price">
              {{selectedProductCard.highPrice}}
              <span class="currency-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
                  <path id="Saudi_Riyal_Symbol"
                    d="M16529.955,11555.947l6.043-1.293a6.589,6.589,0,0,1-.547,2.054l-6.043,1.293A6.683,6.683,0,0,1,16529.955,11555.947Zm-9.41-1.357,5.1-1.092v-2.438l-4.76,1.019a6.632,6.632,0,0,1,.545-2.055l4.215-.9v-7.531a6.609,6.609,0,0,1,1.881-1.59v8.72l1.881-.4v-5.778a6.693,6.693,0,0,1,1.883-1.592v6.967l4.707-1.007a6.588,6.588,0,0,1-.547,2.055l-4.16.89v1.937l4.707-1.008a6.588,6.588,0,0,1-.547,2.055h0l-6.043,1.293v-3.874l-1.881.4v2.149a.926.926,0,0,1-.162.528h0l-.977,1.462a1.7,1.7,0,0,1-1.053.705l-5.338,1.142A6.629,6.629,0,0,1,16520.545,11554.59Z"
                    transform="translate(-16519.998 -11540.001)" fill="#786800" />
                </svg>
              </span>
            </span>
          </div>
        </div>
      </div>

      <div class="mat-dialog-inner">
        <!-- Not available toggle -->
        <div class="not-available control-box">
          <mat-checkbox formControlName="productNotFound" value="" (change)="handelChange()"
            color="primary">{{"monitoringTasks.productNotAvailable"
            | translate}}</mat-checkbox>
        </div>
      </div>

      <div class="warning-box" *ngIf="formGroup.get('productNotFound')?.value">
        <span class="warning-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18.003" height="15.999" viewBox="0 0 18.003 15.999">
            <g id="caution-icon" transform="translate(0 2.084)">
              <path id="Path_25179" data-name="Path 25179"
                d="M26.744,23.475,19.278,36.4a1.536,1.536,0,0,0,1.33,2.3h14.93a1.536,1.536,0,0,0,1.33-2.3L29.4,23.475a1.536,1.536,0,0,0-2.66,0Z"
                transform="translate(-19.072 -24.791)" fill="#ffb02e" />
              <path id="Path_108240" data-name="Path 108240"
                d="M14149.025-9197.036a.815.815,0,0,1,.826-.8.815.815,0,0,1,.832.8.816.816,0,0,1-.832.807A.816.816,0,0,1,14149.025-9197.036Zm-.027-2.867v-3.295a.818.818,0,0,1,.83-.8.814.814,0,0,1,.828.8v3.295a.818.818,0,0,1-.828.806A.823.823,0,0,1,14149-9199.9Z"
                transform="translate(-14140.84 9206.65)" fill="#fff" />
            </g>
          </svg>
        </span>
        <span class="warning-text">
          {{"monitoringTasks.productNotFoundPriceNotRequired" | translate}}
        </span>
      </div>

      <div class="mat-dialog-inner">
        <div class="form-group">
          <mat-form-field>
            <mat-label>{{"monitoringTasks.currentPrice" | translate}}</mat-label>
            <input class="input-decimal" matInput formControlName="currentPrice" [required]="!formGroup.get('productNotFound')?.value"
              appOnlyDecimal maxlength="10">
            <span matSuffix>
              <img src="./assets/images/icons/Saudi_Riyal_Symbol.svg" alt="">
            </span>
            <mat-error *ngIf="hasError('currentPrice', 'required')">
              {{ 'monitoringTasks.observedPriceRequiredValidation' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="mat-dialog-inner" [hidden]="formGroup.get('productNotFound')?.value ?  true: false">
        <div class="control-box">
          <div class="slide-toggle">
            <mat-slide-toggle class="mx-2" formControlName="isPromotionalOffer"
              (change)="handelPromotionalOfferChange($event)"></mat-slide-toggle>
            <label> {{ 'monitoringTasks.hasPromotionOrDiscount' | translate }}</label>
          </div>
          <div class="form-group" [hidden]="!formGroup.controls['isPromotionalOffer'].value">
            <mat-form-field>
              <mat-label>{{"monitoringTasks.productPriceBeforeOffer" | translate}}</mat-label>
              <input matInput formControlName="productPriceBeforePromotion"
                [required]="formGroup.get('isPromotionalOffer')?.value" appOnlyDecimal class="input-decimal">
              <span matSuffix>
                <img src="./assets/images/icons/Saudi_Riyal_Symbol.svg" alt="">
              </span>
              <mat-error *ngIf="hasError('productPriceBeforePromotion', 'required')">
                {{ 'monitoringTasks.priceBeforeDiscountIsRequired' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="warning-box" *ngIf="isRequired() && formGroup.get('currentPrice')?.value">
        <span class="warning-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18.003" height="15.999" viewBox="0 0 18.003 15.999">
            <g id="caution-icon" transform="translate(0 2.084)">
              <path id="Path_25179" data-name="Path 25179"
                d="M26.744,23.475,19.278,36.4a1.536,1.536,0,0,0,1.33,2.3h14.93a1.536,1.536,0,0,0,1.33-2.3L29.4,23.475a1.536,1.536,0,0,0-2.66,0Z"
                transform="translate(-19.072 -24.791)" fill="#ffb02e" />
              <path id="Path_108240" data-name="Path 108240"
                d="M14149.025-9197.036a.815.815,0,0,1,.826-.8.815.815,0,0,1,.832.8.816.816,0,0,1-.832.807A.816.816,0,0,1,14149.025-9197.036Zm-.027-2.867v-3.295a.818.818,0,0,1,.83-.8.814.814,0,0,1,.828.8v3.295a.818.818,0,0,1-.828.806A.823.823,0,0,1,14149-9199.9Z"
                transform="translate(-14140.84 9206.65)" fill="#fff" />
            </g>
          </svg>
        </span>
        <span class="warning-text">
          {{"monitoringTasks.priceOutOfRangeWarning" | translate}}
        </span>
      </div>

      <div class="mat-dialog-inner mb-0">
        <div class="form-element">
          <div class="form-group">
            <label class="mb-2">
              {{"monitoringTasks.attachPriceOrProductImageOptional"|translate}}
              <ng-container *ngIf="!isRequired()">
                ({{"forms.Optional"|translate}})
              </ng-container>
            </label>
            <app-file-manager [files]='files' [isRequired]="isRequired()" [maxSize]='5' [isSubmitted]="isSubmitted"
              [allowedExt]="['png', 'jpg', 'jpeg']" [maxFiles]="1" (selectedFiles)="onFilesSelected($event)"
              (deletedFilesList)="onFilesDeleted($event)"
              [required]="'monitoringTasks.pleaseAttachPriceOrProductImage'"></app-file-manager>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" class="btn-grey" [disabled]="loading" (click)="openConfirmDialog()">
      {{"forms.Cancel" | translate}}
    </button>
    <button (click)="saveRecord()" *ngIf="selectedIndex < products.length - 1" mat-raised-button color="primary"
      [disabled]="loading" [class.loading]="loading">
      {{ "general.saveAndNext" | translate}}
    </button>
    <button (click)="saveRecord(true)" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
      {{ "general.saveAndClose" | translate}}
    </button>
  </mat-dialog-actions>
</form>
